var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditprice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_price",
    "data-name": "edit price",
    transform: "translate(-3.996 -2.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit-2",
    d: "M16.184,16.453H4.811a.8.8,0,1,0,0,1.6H16.184a.8.8,0,1,0,0-1.6Zm-11.372-1.6h.073l3.387-.3a1.633,1.633,0,0,0,.983-.457l7.311-7.221a1.527,1.527,0,0,0-.057-2.174l-2.226-2.2a1.64,1.64,0,0,0-2.161-.056L4.811,9.657a1.6,1.6,0,0,0-.463.971L4,13.974a.8.8,0,0,0,.236.642A.818.818,0,0,0,4.811,14.848ZM13.154,3.616l2.218,2.19L13.747,7.371,11.57,5.221ZM5.924,10.765,10.5,6.28l2.193,2.166L8.142,12.939l-2.437.225Z",
    transform: "translate(0 0)",
    fill: "#b07f4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditprice);
export default __webpack_public_path__ + "static/media/editprice.1454bc11665e9bee1a8496f6bbccc1cb.svg";
export { ForwardRef as ReactComponent };